import { init, configureScope } from '@sentry/browser';

init({
  environment: process.env.NODE_ENV,
  dsn: process.env.SENTRY_DSN_FE,
  sampleRate: 0.15,
  tracesSampleRate: 0,
});
